import { render, staticRenderFns } from "./ProfileWidget.vue?vue&type=template&id=1cbb80d4&"
import script from "./ProfileWidget.vue?vue&type=script&lang=ts&"
export * from "./ProfileWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports